import { PreviewPrintOrderRequest, RenderPrintOrderRequest } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

type HtmlSanitizer = (html: string) => string;

const showHtmlInWindow = (html: string): void => {
	const blob = new Blob([html], { type: 'text/html; charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const newWindow = window.open(url, '_blank');
	if (!newWindow) {
		URL.revokeObjectURL(url);
		throw new Error('Unable to open window');
	}
};
const printReceipt = async (payload: RenderPrintOrderRequest, sanitize: HtmlSanitizer): Promise<void> => {
	const html = await getRootEnv().dashboardSdk.sdk.templatesApi.receipt(payload);
	showHtmlInWindow(sanitize(html));
};

const printPreview = async (payload: PreviewPrintOrderRequest, sanitize: HtmlSanitizer): Promise<void> => {
	const html = await getRootEnv().dashboardSdk.sdk.templatesApi.preview(payload);
	showHtmlInWindow(sanitize(html));
};

export const orderReceiptPrintingProvider = {
	printReceipt,
	printPreview
};
